// covered-by: frontends/carrie/src/ask-v2/services/__tests__/homeCopy.test.ts
import {
  type AskPunttHomeCopyClientTime,
  type GetAskPunttHomeCopyResponse,
  getAskPunttHomeCopyResponseSchema,
} from "@mg/schemas/src/christo/askPunttHomeCopy";

import { API_URL } from "../../config/env";
import { smartFetch } from "../../utils/http";

export const ASK_V2_HOME_COPY_QUERY_KEY = ["ask-v2", "home-copy"] as const;

const homeCopyUrl = `${API_URL}/private/catalyst/ask-puntt/home-copy`;

/**
 * Ask christo for the personalized home headline and the get-started line
 * under it. The client clock goes up so the server can greet the reader's
 * actual morning or evening; `copy` is null when christo could not
 * personalize.
 */
export async function getHomeCopy(
  clientTime: AskPunttHomeCopyClientTime,
): Promise<GetAskPunttHomeCopyResponse> {
  const json = await smartFetch(homeCopyUrl, {
    method: "POST",
    body: JSON.stringify(clientTime),
  });
  return getAskPunttHomeCopyResponseSchema.parse(json);
}
